import WhatsAppLightBg from './img/WhatsApp-light-bg.png';
import googleCalendarIcon from './svg/google-calendar.svg';

const Assets = {
  images: {
    WhatsAppLightBg,
    defaultProfilePic:
      'https://tagmango.com/staticassets/avatar-placeholder.png-1612857612139.png',
    tqConnectShoutoutPreview:
      'https://testing.tagmango.com/publicassets/-cover-7026f8b17db55970a7de614ecf419d68.png',
  },
  links: {
    termsAndConditionsPage: 'https://tagmango.com/terms',
    privacyPolicyPage: 'https://tagmango.com/privacy-policy',
  },
  svg: {
    googleCalendarIcon,
    fullMarksCelebration:
      'https://testing.tagmango.com/assets/Background-cd8738609cfe24f96ac85badbec641dc.svg',
    tqConnectSetupPreview:
      'https://testing.tagmango.com/publicassets/-frame-1261156247-9df534811f9365f35fdbc6d59b54e3d3.svg',
  },
  audios: {
    // notificationSound:
    //   'https://testing.tagmango.com/publicassets/-mixkit-software-interface-start-2574-fd005be7412882a792a9ffd66e5437f8.wav',
    notificationSound:
      'https://testing.tagmango.com/publicassets/-mixkit-correct-answer-tone-2870-9e6b8ba15f21917de59b5509fb0ce2a8.wav',
  },
};

export default Assets;
